import { applyMiddleware, createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { composeWithDevTools } from 'redux-devtools-extension'
import storage from 'redux-persist/lib/storage'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import * as Sentry from '@sentry/react'

import rootReducer from './reducers'
import rootSaga from './sagas'

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer<any>(persistConfig, rootReducer)

export default () => {
  const middlewares = []

  const sagaMiddleware = createSagaMiddleware()
  const sentryReduxEnhancer = Sentry.createReduxEnhancer()

  if (process.env.NODE_ENV !== 'production') {
    const loggerOptions = {
      collapsed: true,
      duration: true,
    }
    const logger = createLogger(loggerOptions)
    middlewares.push(logger)
  }

  middlewares.push(sagaMiddleware)

  const store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(...middlewares), sentryReduxEnhancer)
  )
  const persistor = persistStore(store)

  sagaMiddleware.run(rootSaga)

  return { store, persistor }
}
